import { render, staticRenderFns } from "./SimpleForm.vue?vue&type=template&id=cf5dd24c&scoped=true"
import script from "./SimpleForm.vue?vue&type=script&lang=js"
export * from "./SimpleForm.vue?vue&type=script&lang=js"
import style0 from "./SimpleForm.vue?vue&type=style&index=0&id=cf5dd24c&prod&scoped=true&lang=scss"
import style1 from "./SimpleForm.vue?vue&type=style&index=1&id=cf5dd24c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5dd24c",
  null
  
)

export default component.exports